import { render, staticRenderFns } from "./Transaction1.vue?vue&type=template&id=624ab476&scoped=true&"
import script from "./Transaction1.vue?vue&type=script&lang=js&"
export * from "./Transaction1.vue?vue&type=script&lang=js&"
import style0 from "./Transaction1.vue?vue&type=style&index=0&id=624ab476&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624ab476",
  null
  
)

export default component.exports